/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ng-dirty.ng-invalid[_nghost-%COMP%]   button[_ngcontent-%COMP%], .ng-dirty.ng-invalid[_nghost-%COMP%]   input[_ngcontent-%COMP%], .ng-touched.ng-invalid[_nghost-%COMP%]   button[_ngcontent-%COMP%], .ng-touched.ng-invalid[_nghost-%COMP%]   input[_ngcontent-%COMP%]{background-color:#fff;border:2px solid #be0000;color:#be0000}"];
export { styles as styles };
